import { Injectable, ViewContainerRef } from '@angular/core';

/**
 * Service to hold a reference to the global dropdown overlay container.
 */
@Injectable({
  providedIn: 'root'
})
export class DropdownOverlayService {
  /**
   * The global overlay container where dropdown menus are rendered.
   */
  public containerRef: ViewContainerRef | null = null;
}
